import { Card, CardHeader, CardContent, Stack, TextField, CardActions, Modal } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { categorySchema } from '../schemas/categorySchemas';
import { updateCategory, resetCategoryState } from '../store/categoryActions';

CategoryEditForm.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  category: PropTypes.object,
};

export default function CategoryEditForm({ category, open, onClose }) {
  console.log(category);
  const dispatch = useDispatch();
  const { isLoading, isSuccess } = useSelector((state) => state.categoryReducer);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      id: '',
      name: '',
      code: '',
      depreciation_rate: '',
      description: '',
    },
    resolver: yupResolver(categorySchema),
  });

  useEffect(() => {
    if (category) {
      reset({
        id: category?.id || '',
        name: category?.name || '',
        code: category?.code || '',
        depreciation_rate: category?.depreciation_rate || 0,
        description: category?.description || '',
      });
    }
  }, [category, reset]);

  useEffect(() => {
    if (isSuccess) {
      onClose();
    }
  }, [isSuccess, onClose]);

  const onSubmit = async (values) => {
    if (!values?.id) return;
    const payload = {
      id: values?.id,
      payload: values,
    };
    dispatch(updateCategory(payload));
  };

  const handleClose = () => {
    reset();
    dispatch(resetCategoryState());
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '340px', md: '600px' },
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: { xs: '0px', md: '2px' },
          alignItems: 'center',
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <CardHeader title="Edit Category" />
          <CardContent>
            <Stack spacing={3}>
              <Controller
                name="name"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="text"
                    label="Category Name"
                    error={Boolean(errors.name)}
                    helperText={errors.name?.message}
                  />
                )}
              />

              <Controller
                name="code"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="text"
                    label="Category Code"
                    error={Boolean(errors.code)}
                    helperText={errors.code?.message}
                  />
                )}
              />

              <Controller
                name="depreciation_rate"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="number"
                    label="Depreciation Rate (%)"
                    error={Boolean(errors.depreciation_rate)}
                    helperText={errors.depreciation_rate?.message}
                    inputProps={{ min: 0, max: 100, step: 0.01 }}
                  />
                )}
              />

              {/* <Controller
                name="description"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="text"
                    label="Description (Optional)"
                    multiline
                    rows={3}
                    error={Boolean(errors.description)}
                    helperText={errors.description?.message}
                  />
                )}
              /> */}
            </Stack>
          </CardContent>
          <CardActions sx={{ p: 3, pt: 0 }}>
            <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'flex-end' }}>
              <LoadingButton variant="outlined" onClick={handleClose} disabled={isLoading}>
                Cancel
              </LoadingButton>
              <LoadingButton type="submit" variant="contained" loading={isLoading} disabled={isSubmitting}>
                Update Category
              </LoadingButton>
            </Stack>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
}
